import { BarcodeIcon, CheckIcon, CopyIcon } from "@phosphor-icons/react"
import { JuloBadge } from "@repo/ui/components/julo-badge"
import { useEffect, useRef, useState } from "react"
import { useTranslations } from "use-intl"

interface ProductEanBadgeProps {
  ean: string | null | undefined
  truncate?: boolean
}

export const ProductEanBadge = ({
  ean,
  truncate = false,
}: ProductEanBadgeProps) => {
  const t = useTranslations("ui.productEanBadge")
  const [copied, setCopied] = useState(false)
  const resetTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (resetTimeoutRef.current) clearTimeout(resetTimeoutRef.current)
    }
  }, [])

  if (!ean) return null

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(ean)
    } catch {
      return
    }
    setCopied(true)
    if (resetTimeoutRef.current) clearTimeout(resetTimeoutRef.current)
    resetTimeoutRef.current = setTimeout(() => setCopied(false), 3000)
  }

  return (
    <JuloBadge
      truncate={truncate}
      leftIcon={<BarcodeIcon weight="regular" />}
      rightAction={{
        icon: copied ? <CheckIcon /> : <CopyIcon />,
        onClick: handleCopy,
        ariaLabel: t("copyEan"),
      }}
    >
      {ean}
    </JuloBadge>
  )
}
